<template>
    <NewPreOrder
        :show="show"
        :show-client-select="!hasClientRole"
        :customers="customers"
        :designers="designers"
        @update:show="$emit('update:show', $event)"
        @addPreOrder="addNewPreOrder"
        @searchDesigners="executeSearchDesigners"
        @searchCustomers="executeSearchCustomers"
    />
</template>
<script>
import { mapActions } from "vuex";
import NewPreOrder from "./_components/NewPreOrder.vue";
import { getters } from "src/global-store.js";

export default {
    name: "NewPreOrderModule",
    components: { NewPreOrder },
    props: {
        show: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            customers: [],
            designers: [],
        };
    },
    computed: {
        hasClientRole() {
            return getters.hasClientRole();
        },
    },
    methods: {
        ...mapActions("customer", ["searchCustomers"]),
        ...mapActions("designer", ["searchDesigners"]),
        ...mapActions("$_preOrder", ["addPreOrder"]),
        async addNewPreOrder(data) {
            const preOrder = await this.addPreOrder(data);
            this.$emit("update:show", false);
            this.$router.push(`/preorder/${preOrder.id}`);
        },
        async executeSearchCustomers({ search, loading }) {
            loading(true);
            this.customers = await this.searchCustomers(search);
            loading(false);
        },
        async executeSearchDesigners({ search, loading }) {
            loading(true);
            this.designers = await this.searchDesigners(search);
            loading(false);
        },
    },
};
</script>
